import React, { Component } from 'react';
import { Grid, Stepper, Step, StepLabel, Paper } from '@material-ui/core';
import Quote from './Quote';
import Payment from './Payment';
import { OrderFinalizationProps } from '../connected/OrderFinalizationCnnctd';
import OrderFinished from './OrderFinished';
import { roundedCorners } from '../../QmoTheme';
import LogoAndTitle from '../../Layout/components/LogoAndTitle';

type State = {
    value: number,
    steps: string[],
    activeStep: number,
    orderFinished: boolean
}

class OrderFinalization extends Component<OrderFinalizationProps, State> {
    constructor(props: OrderFinalizationProps) {
        super(props)

        this.state = {
            value: 0,
            steps: ['Quote', 'Pay & Order'],
            activeStep: 0,
            orderFinished: false
        }
    }

    getStepContent(activeStep: number) {
        if (activeStep === 0)
            return (<Quote
                deliveryAddress={this.props.restaurantDetails}
                getDeliveryAddress={this.props.getRestaurantAccountInfo}
                getDeliveryAddressBusy={this.props.getDeliveryAddressBusy}
                quotedOrder={this.props.quotedOrder}
                orderSheet={this.props.orderSheet!}
                goNext={() => { this.props.getPaymentIntent(this.props.currentOrderId);this.handleNext() }}
                isBusy={this.props.quoteBusy}
                noneFulfillsOrder={this.props.noneFulfillsOrder}
                noneFulfillsDeadline={this.props.noneFulfillsDeadline}
                missingProducts={this.props.missingProducts}
            />)
        else
            if (activeStep === 1)
                return (<Payment
                    orderSheet={this.props.orderSheet!}
                    finalizeOrder={this.props.finalizeOrder}
                    currentOrderId={this.props.currentOrderId}
                    quotedOrder={this.props.quotedOrder}
                    
                    getPaymentIntentBusy={this.props.getPaymentIntentBusy}
                    paymentIntentSecret={this.props.paymentIntentSecret}
                    paymentCards={this.props.paymentCards}
                    goNext={this.handleNext} />)
    }

    handleNext = () => {
        if (this.state.activeStep + 1 === this.state.steps.length)
            this.setState({ orderFinished: true })
        else
            this.setState({ activeStep: this.state.activeStep + 1 })
    }
    handleBack = () => {
        this.setState({ activeStep: this.state.activeStep - 1 })
    }

    render() {
        return (
            <Grid container alignItems="center">
                <Grid item xs={12} sm={12} style={{ paddingBottom: '15px' }}>

                    <LogoAndTitle title="Order placement" />
                    {this.state.orderFinished === false ?
                        <div>
                            <Stepper activeStep={this.state.activeStep} style={{ backgroundColor: "transparent" }} alternativeLabel>

                                {this.state.steps.map((label, i) => (
                                    <Step key={label}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                            <Paper style={Object.assign({ padding: '30px' }, roundedCorners)}>
                                {this.getStepContent(this.state.activeStep)}
                            </Paper>

                        </div>
                        :
                        <Paper style={Object.assign({ padding: '30px' }, roundedCorners)}>
                            <OrderFinished missingProducts={this.props.missingProducts} resetOrder={this.props.resetOrder} quotedOrder={this.props.quotedOrder} deliveryAddress={this.props.restaurantDetails} getDeliveryAddress={this.props.getRestaurantAccountInfo} getDeliveryAddressBusy={this.props.getDeliveryAddressBusy} />
                        </Paper>
                    }
                </Grid>
            </Grid>
        );
    }
}

export default OrderFinalization;